<template>
    <app-layout>
        <div class="py-12">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="brandGuidelinesManage">
                    <div class="container">
                        <div class="row">
                            <h1 class="text-2xl font-bold mb-4">Brand Guidelines Manage</h1>

                            <div class="col-12">
                                <div class="mb-6">
                                    <div class="text-xl font-bold mb-4">Last Updated</div>
                                    <FormDatepicker
                                        class="mb-6"
                                        v-model="form.last_updated"
                                        id="last_updated"
                                        placeholderText="Last Updated"
                                    />
                                    <button
                                        class="
                                            bg-blue-500
                                            hover:bg-blue-700
                                            text-white
                                            font-bold
                                            py-2
                                            px-4
                                        "
                                        @click="save('lastupdated')"
                                    >
                                        Save
                                    </button>
                                </div>
                                <hr class="py-2" />
                            </div>

                            <div class="col-12">
                                <OverviewUpload @uploadComplete="fetch" guidelineOverview="guidelineOverview"></OverviewUpload>
                                
                                <div class="assets">
                                    <div class="overview-list">
                                        <table id="myTable">
                                            <tr class="header">
                                                <th id="assets">Guideline Overview items</th>
                                            </tr>
                                            <!-- To change v-model value to existingAssets -->
                                            <draggable class=""
                                                tag="tbody"
                                                v-model="guidelineOverview"
                                                v-bind="dragOptions"
                                                item-key="id"
                                                :move="onMove"
                                                @end="onEndOverview">
                                                    <template #item="{ element, index }">
                                                        <tr>
                                                            <td>
                                                                <a class="pdf-white" :href="'/brand-guideline-overview/' + element.id" >{{ element.label }}</a>
                                                            </td>
                                                        </tr>
                                                    </template>
                                            </draggable>
                                        </table>
                                    </div>
                                </div>
                                <hr class="py-2" />
                            </div>

                            <div class="col-12">
                                <div class="file-upload">
                                    <div class="text-xl font-bold mb-4">Brand Guidelines upload</div>
                                    <div>
                                        <BrandGuidelinesUpload @uploadComplete="fetch"></BrandGuidelinesUpload>
                                    </div>
                                </div>
                                <div class="assets">
                                    <div class="overview-list">
                                        <table id="myTable">
                                            <tr class="header">
                                                <th id="assets">Brand Guidelines</th>
                                            </tr>
                                            <tr v-if="guideline">
                                                <td>
                                                    <input v-model="guideline.label"
                                                        name="guideline_label"
                                                        type="text"
                                                        class="
                                                            shadow-sm
                                                            focus:ring-indigo-500 focus:border-indigo-500
                                                            block
                                                            w-full
                                                            sm:text-sm
                                                            border-gray-300
                                                            mb-6
                                                        " />

                                                    <button
                                                        class="
                                                            bg-blue-500
                                                            hover:bg-blue-700
                                                            text-white
                                                            font-bold
                                                            py-2
                                                            px-4
                                                        "
                                                        @click="save('brand-guideline')"
                                                    >
                                                        Save
                                                    </button>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                                <hr class="py-2" />
                            </div>

                            <div class="col-12">
                                <div class="file-upload">
                                    <div class="text-xl font-bold mb-4">Master Brand Quick Reference upload</div>
                                    <div>
                                        <BrandQuickRefUpload @uploadComplete="fetch"></BrandQuickRefUpload>
                                    </div>
                                </div>
                                <div class="assets">
                                    <div class="overview-list">
                                        <table id="myTable">
                                            <tr class="header">
                                                <th id="assets">Brand Guideline Quick Reference</th>
                                            </tr>
                                            <tr v-if="quickReference">                                            
                                                <td>
                                                    <input v-model="quickReference.label"
                                                        name="guideline_label"
                                                        type="text"
                                                        class="
                                                            shadow-sm
                                                            focus:ring-indigo-500 focus:border-indigo-500
                                                            block
                                                            w-full
                                                            sm:text-sm
                                                            border-gray-300
                                                            mb-6
                                                        " />

                                                    <button
                                                        class="
                                                            bg-blue-500
                                                            hover:bg-blue-700
                                                            text-white
                                                            font-bold
                                                            py-2
                                                            px-4
                                                        "
                                                        @click="save('brand-guideline-quick-reference')"
                                                    >
                                                        Save
                                                    </button>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                                <hr class="py-2" />
                            </div>

                            <div class="col-12">
                                <div class="file-upload">
                                    <div class="text-xl font-bold mb-4">All bundled Guideline Assets upload</div>
                                    <div>
                                        <BundledAssetsUpload @uploadComplete="fetch"></BundledAssetsUpload>
                                    </div>
                                </div>
                                <div class="assets">
                                    <div class="overview-list">
                                        <table id="myTable">
                                            <tr class="header">
                                                <th id="assets">Bundled Guideline Assets file</th>
                                            </tr>
                                            <tr v-if="bundledAssets">
                                                <td>
                                                    <span class="pdf-white" >{{ bundledAssets.label }} ({{ bundledAssets.byte }})</span>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                                <hr class="py-2" />
                            </div>

                            <div class="col-12">
                                <div class="file-upload">
                                    <div class="text-xl font-bold mb-4">Guideline assets upload</div>
                                    <div>
                                        <AssetsUpload @uploadComplete="fetch"></AssetsUpload>
                                    </div>
                                </div>
                                <div class="assets">
                                    <div class="overview-list">
                                        <table id="myTable">
                                            <tr class="header">
                                                <th id="assets">{{json.AssetsTitle}} <p>{{json.AssetsDescription}}</p></th>
                                            </tr>
                                            <draggable class=""
                                                tag="tbody"
                                                v-model="guidelineAssets"
                                                v-bind="dragOptions"
                                                item-key="id"
                                                :move="onMove"
                                                @end="onEnd">
                                                    <template #item="{ element, index }">
                                                        <tr>
                                                            <td>
                                                                <a class="pdf-white" :href="'/brand-guideline-assets/' + element.id" >{{ element.label }} ({{ element.byte }})</a>
                                                            </td>
                                                        </tr>
                                                    </template>
                                            </draggable>
                                        </table>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </app-layout>
</template>

<script>
// import json from '../../../../brand-portal/src/assets/data/BrandGuidelines.json';
import draggable from "vuedraggable";
import axios from 'axios';
import AssetsUpload from "@/Pages/Guidelines/AssetsUpload";
import OverviewUpload from "@/Pages/Guidelines/OverviewUpload";
import BrandQuickRefUpload from "@/Pages/Guidelines/BrandQuickRefUpload";
import BrandGuidelinesUpload from "@/Pages/Guidelines/BrandGuidelinesUpload";
import BundledAssetsUpload from "@/Pages/Guidelines/BundledAssetsUpload";
import AppLayout from '@/Layouts/AppLayout';
import FormDatepicker from "@/components/FormDatepicker";
import "flatpickr/dist/flatpickr.css";

export default {
    components: {
        draggable,
        AssetsUpload,
        OverviewUpload,
        BrandQuickRefUpload,
        BrandGuidelinesUpload,
        BundledAssetsUpload,
        AppLayout,
        FormDatepicker,
    },
    computed: {
        dragOptions() {
            return {
                animation: 200,
                group: "description",
                disabled: false,
                ghostClass: "ghost"
            };
        }
    },
    data() {
        let json = {
            "AssetsTitle": "Guideline Assets",
            "AssetsDescription": "Drag and drop to sort the guideline assets. Click on the asset name to view or edit the asset."
        };

        return {
            datePickerConfig: {
                enableTime: false,
                altInput: true,
                altFormat: "d F Y",
                dateFormat: "d F Y",
            },
            form: {},
            json,
            guideline: {},
            quickReference: {},
            guidelineAssets: [],
            guidelineOverview: [],
            bundledAssets: {},
            item: null,
        }
    },
    methods: {
        fetch() {
            axios.get(`/api/brand-guidelines`).then((response) => {
                this.guideline = response.data.guideline;
                this.quickReference = response.data.quickReference;
                this.guidelineAssets = response.data.assets;
                this.guidelineOverview = response.data.guidelineOverview;
                this.bundledAssets = response.data.bundledAssets;
                this.form.last_updated = response.data.last_updated.last_updated;
            });
        },
        save(type) {
            this.isLoading = true;

            if (typeof type !== "undefined" && type != null) {
                this.form.type = type;

                if (type == "brand-guideline") {
                    this.form.label = this.guideline.label
                } else if (type == "brand-guideline-quick-reference") {
                    this.form.label = this.quickReference.label
                }

                axios
                    .post(`/api/brand-guideline-update`, this.form)
                    .then((response) => {
                        this.fetch();
                    })
                    .catch((error) => {
                        this.savedError();
                        if (error.response) {
                            if (error.response.status === 422) {
                                this.errors = error.response.data.errors;
                            }
                        } else if (error.request) {
                            // console.log(error.request);
                        } else {
                            // console.log("Error", error.message);
                        }
                    });
            }

            this.isLoading = false;
        },
        onMove: function(event) {            
            this.item = event.draggedContext.element.id;
        },
        onEnd(event) {
            if (this.item != null) {
                axios.put('/api/brand-guideline-sort', {
                    id: this.item,
                    new_index: event.newIndex + 1,
                    type: "brand-guideline-assets",
                })
                .then(response => {
                    this.fetch();
                })
                .catch(error => {
                    console.error('Error updating order:', error);
                });
            }            
        },
        onEndOverview(event) {
            if (this.item != null) {
                axios.put('/api/brand-guideline-sort', {
                    id: this.item,
                    new_index: event.newIndex + 1,
                    type: "brand-guideline-overview",
                })
                .then(response => {
                    this.fetch();
                })
                .catch(error => {
                    console.error('Error updating order:', error);
                });
            }            
        }
    },
    mounted() {
        this.fetch();
    }
}
</script>

<style src="@vueform/multiselect/themes/default.css"></style>

<style lang="css" scoped>
    h1 {
        margin-bottom: 30px;
    }

    .file-upload, .assets {
        margin-bottom: 30px;
    }

    a.pdf-white {
        color: inherit;
    }

    #myTable {
        border-collapse: collapse; /* Collapse borders */
        width: 100%; /* Full-width */
        border: 1px solid #ddd; /* Add a grey border */
        font-size: 18px; /* Increase font-size */
    }

    #myTable th, #myTable td {
        text-align: left; /* Left-align text */
        padding: 12px; /* Add padding */
    }

    #myTable tr {
        /* Add a bottom border to all table rows */
        border-bottom: 1px solid #ddd;
    }

    #myTable tr.header, #myTable tr:hover {
        /* Add a grey background color to the table header and on hover */
        background-color: #f1f1f1;
    }


</style>
